import { ReactElement } from 'react';

import { Money } from '@dreryk/money-common-api';

import { getCustomFormattingContext, priceRangeFormatter } from '@dreryk/react-common';
import { Text } from '@dreryk/react-components';

type PriceCellProps = {
   readonly min: Money;
   readonly max: Money;
};

export const PriceCell = (props: PriceCellProps): ReactElement => {
   return (
      <Text testId={'price'}>
         {priceRangeFormatter(
            {
               min: props.min.asNumber(),
               max: props.max.asNumber(),
            },
            getCustomFormattingContext({
               options: {
                  currency: 'PLN',
                  stripDecimalZeroes: true,
               },
            })
         )}
      </Text>
   );
};
